<template>
    <div>
        <DateTime :value="startDate" :date-image="require(`@/assets/img/icon_pickup.svg`)" @input="$emit('startDateChanged', $event)" class="mb3" />
        <DateTime :value="endDate" :date-image="require(`@/assets/img/icon_dropoff.svg`)" @input="$emit('endDateChanged', $event)" class="mb3" />
    </div>
</template>

<script>
import DateTime from '@/components/global/DateTime.vue';

export default {
    components: {
        DateTime
    },
    props: {
        startDate: {
            type: String
        },
        endDate: {
            type: String
        }
    }
};
</script>
